module.exports = __webpack_public_path__ + "static/img/logo.82dd517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wnq/logo.jpg
// module id = O/J+
// module chunks = 230